/* eslint-disable no-console */
import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_SLOTTED_SEARCH_VIEWS_START = 'GET_SLOTTED_SEARCH_VIEWS_START';
export const GET_SLOTTED_SEARCH_VIEWS_SUCCESS = 'GET_SLOTTED_SEARCH_VIEWS_SUCCESS';
export const GET_SLOTTED_SEARCH_VIEWS_ERROR = 'GET_SLOTTED_SEARCH_VIEWS_ERROR';

export const GET_SLOTTED_SEARCH_SELECTED_VIEW_START = 'GET_SLOTTED_SEARCH_SELECTED_VIEW_START';
export const GET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS = 'GET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS';
export const GET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR = 'GET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR';

export const SET_SLOTTED_SEARCH_SELECTED_VIEW_START = 'SET_SLOTTED_SEARCH_SELECTED_VIEW_START';
export const SET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS = 'SET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS';
export const SET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR = 'SET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR';

export const GET_SLOTTED_SEARCH_JOB_DETAILS_START = 'GET_SLOTTED_SEARCH_JOB_DETAILS_START';
export const GET_SLOTTED_SEARCH_JOB_DETAILS_SUCCESS = 'GET_SLOTTED_SEARCH_JOB_DETAILS_SUCCESS';
export const GET_SLOTTED_SEARCH_JOB_DETAILS_ERROR = 'GET_SLOTTED_SEARCH_JOB_DETAILS_ERROR';

export const SET_SLOTTED_CURRENCY = 'SET_SLOTTED_CURRENCY';

const SLOTTED_SEARCH_NAME = 'price';

/*
  Get a list of views for the slotted search dropdown
*/
export function getSlottedSearchViews(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving slotted views';

    try {
      dispatch({ type: GET_SLOTTED_SEARCH_VIEWS_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views`, {
        params: {
          contextName: SLOTTED_SEARCH_NAME,
          portAll: true,
          isFacet: false
        }
      });

      if (result.status < 300) {
        dispatch({
          type: GET_SLOTTED_SEARCH_VIEWS_SUCCESS,
          views: result.data?.data?.views,
          defaultViewId: result.data?.data?.defaultViewId
        });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch error in getSlottedSearchViews: ', error);
      dispatch({ type: GET_SLOTTED_SEARCH_VIEWS_ERROR });
    }
  };
}

/*
  Get the selected view for the Market Pricing Slotted Search, which is set in the db
*/
export function getSlottedSearchSelectedView(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving selected slotted view';

    try {
      dispatch({ type: GET_SLOTTED_SEARCH_SELECTED_VIEW_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        params: {
          contextName: SLOTTED_SEARCH_NAME
        }
      });

      if (result.status < 300) {
        dispatch({ type: GET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS, selectedViewPk: result.data?.data?.view_pk });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch error in getSlottedSearchSelectedView: ', error);
      dispatch({ type: GET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR });
    }
  };
}

/*
  Set the selected view for the Market Pricing Slotted Search, which is set in the db
*/
export function setSlottedSearchSelectedView(viewPk, masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error setting selected slotted view';

    try {
      dispatch({ type: SET_SLOTTED_SEARCH_SELECTED_VIEW_START });

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        contextName: SLOTTED_SEARCH_NAME,
        viewId: viewPk
      });

      if (result.status < 300) {
        dispatch({ type: SET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS, selectedViewPk: viewPk });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch in setSlottedSearchSelectedView: ', error);
      dispatch({ type: SET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR });
    }
  };
}

export function setSlottedCurrency(currency) {
  return { type: SET_SLOTTED_CURRENCY, currency };
}
